"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ParsableError {
    constructor(error) {
        this.error = error;
    }
    isResponseExist() {
        return typeof this.error.response === 'object';
    }
    isResponseDataExist() {
        return typeof this.error.response.data === 'object';
    }
    isErrorObjectExist() {
        return typeof this.error.response.data.error === 'object';
    }
    isErrorMessageExist() {
        return !!this.error.response.data.error.message;
    }
    isErrorCodeExist() {
        return !!this.error.response.data.error.code;
    }
    hasErrorMessage() {
        if (!this.isResponseExist())
            return false;
        if (!this.isResponseDataExist())
            return false;
        if (!this.isErrorObjectExist())
            return false;
        if (!this.isErrorMessageExist())
            return false;
        return true;
    }
    hasErrorCode() {
        if (!this.isResponseExist())
            return false;
        if (!this.isResponseDataExist())
            return false;
        if (!this.isErrorObjectExist())
            return false;
        if (!this.isErrorCodeExist())
            return false;
        return true;
    }
    getMessage() {
        if (this.hasErrorMessage())
            return this.error.response.data.error.message;
        return this.error.message;
    }
    getCode() {
        if (this.hasErrorCode())
            return this.error.response.data.error.code;
        return 'UNKNOWN';
    }
    static parseErrorMessage(error) {
        const pError = new ParsableError(error);
        return pError.getMessage();
    }
    static parseErrorCode(error) {
        const pError = new ParsableError(error);
        return pError.getCode();
    }
}
exports.default = ParsableError;
//# sourceMappingURL=ParsableError.js.map